/**
 * Builds the payload every hub-emitted analytics row carries.
 *
 * Kept as a pure module so the debug stamp is testable without rendering the provider, which is
 * where the rule that matters lives: `isDebug` is applied **after** the caller's payload, so a
 * call site cannot shadow it. The backend drops a flagged row from the stats aggregation while
 * still storing it raw, so a lost flag silently counts a local UE editor as real usage.
 *
 * @param props.visitId - Current visit, null between experiences.
 * @param props.deviceType - Hub device profile, feeding the device and geo counters.
 * @param props.isDebugMode - Whether this tab runs against a local UE editor.
 * @param props.payload - Caller-supplied fields; may override `deviceType` and `visitId`.
 * @returns The payload to send.
 */
export const buildAnalyticsPayload = ({
  visitId,
  deviceType,
  isDebugMode,
  payload,
}: {
  visitId: string | null;
  deviceType: string;
  isDebugMode: boolean;
  payload: Record<string, unknown>;
}): Record<string, unknown> => ({
  deviceType,
  visitId,
  ...payload,
  ...(isDebugMode ? { isDebug: true } : {}),
});
